import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

const syncRippling = () => {
  const newEndpoints = endpoints.integrations.ripplingSync;
  return http().post(newEndpoints, {});
};

export function useSyncRippling() {
  return useMutation({ mutationFn: syncRippling });
}
